<template>
  <div class="container">
    <div
      id="page1-div"
      ref="document"
      class="container interline border page-container"
    >
      <div class="col-12 text-justify">
        <div class="col-12  text-rigth pt-lg-5">
          <span class="ft10Gray">
            <p class="ft10Gray" align="right">
              CD,
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{data.municipio_cliente}},
              </span>
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.estado_cliente }}
              </span>
              A
              <span v-bind:class="{ marca: data.showMarca }" class="ft10Black">
                {{ data.fecha_contrato }}.
              </span>
            </p>
          </span>
        </div>
        <div class="col-12 m-1">
          <span class="ft11">
            GPI AUTO COMERCIAL SAPI DE C.V. <br />
            <br />
          </span>
          <span class="ft11"> P R E S E N T E<br /><br /> </span>
          <span class="ft11"> Con relación a:<br /><br /> </span>
          <div class="col-11">
            <span class="ft11">
              1) El contrato de Crédito
              <u>Simple con Garantía Prendaria</u> de fecha
              <span class="text-secondary"
                ><span v-bind:class="{ marca: data.showMarca }">
                  {{ data.fecha_contrato }}</span
                ></span
              >
              celebrado en la ciudad de CD,<span class="text-secondary"
                ><span v-bind:class="{ marca: data.showMarca }">
                  {{ data.municipio_cliente }}</span
                >,
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.estado_cliente }}</span
                ></span
              >
              <span class="ft11Black">
                <span v-bind:class="{ marca: data.showMarca }">
                  {{ data.fecha_contrato }}</span
                >
              </span>
              de
              <span class="ft11Black"
                ><span v-bind:class="{ marca: data.showMarca }">
                  {{ data.nombre_cliente }}</span
                ></span
              >
              y GPI AUTO COMERCIAL SAPI DE C.V. <br /><br />
            </span>
            <span class="ft11">
              2) Su solicitud respecto de la información de mi conocimiento
              sobre la existencia de Dueño Beneficiario o Beneficiario
              Controlador, y en su caso de los datos, documentos o información
              que permita identificarlo, en términos del Artículo 3 Fracción III
              de la Ley Federal para la Prevención e Identificación de
              Operaciones con Recursos de Procedencia Ilícita que define:
              <br /><br />
            </span>
          </div>

          <span class="ft11it">
            “…Beneficiario Controlador, a la persona o grupo de personas que:<br />
          </span>
          <span class="ft11it">
            a) Por medio de otra o de cualquier acto, obtiene el beneficio
            derivado de éstos y es quien, en última instancia, ejerce los
            derechos de uso, goce, disfrute, aprovechamiento o disposición de un
            bien o servicio, o<br />
          </span>
          <span class="ft11it">
            b) Ejerce el control de aquella persona moral que, en su carácter de
            cliente o usuario, lleve a cabo actos u operaciones con quien
            realice Actividades Vulnerables, así como las personas por cuenta de
            quienes celebra alguno de ellos.<br />
          </span>
          <span class="ft11it">
            Se entiende que una persona o grupo de personas controla a una
            persona moral cuando, a través de la titularidad de valores, por
            contrato o de cualquier otro acto, puede:
            <br />
          </span>
          <span class="ft11it">
            i) Imponer, directa o indirectamente, decisiones en las asambleas
            generales de accionistas, socios u órganos equivalentes, o nombrar o
            destituir a la mayoría de los consejeros, administradores o sus
            equivalentes;
            <br />
          </span>
          <span class="ft11it">
            ii) Mantener la titularidad de los derechos que permitan, directa o
            indirectamente, ejercer el voto respecto de más del cincuenta por
            ciento del capital social, o iii) Dirigir, directa o indirectamente,
            la administración, la estrategia o las principales políticas de la
            misma…”.

            <br /><br />
          </span>
          <span class="ft11">
            Así como del Artículo 14 del Reglamento de la Ley Federal para la
            Prevención e Identificación de Operaciones con Recursos de
            Procedencia Ilícita que establece:

            <br /><br />
          </span>
          <span class="ft11it">
            &emsp;&emsp; “…Artículo 14.- Para efectos del cumplimiento a lo
            previsto en la fracción III del artículo 18 de la Ley, se entenderá
            como dueño beneficiario al Beneficiario Controlador….”

            <br /><br />
          </span>
          <span class="ft11">
            Bajo protesta de decir verdad, habiendo comprendido el concepto de
            Beneficiario Controlador o Dueño Beneficiario, hago saber que NO
            tengo conocimiento de la existencia un Beneficiario Controlador o
            Dueño Beneficiario, en términos de los preceptos arriba mencionados.

            <br /><br />
          </span>
          <div class="col-7 row pt-lg-5">
            <div class="col-3 text-center"></div>
            <div class="col-6  text-center"></div>
            <span class="ft11">
              ATENTAMENTE
            </span>
          </div>
          <div class="col-10 row pt-lg-5">
            <div class="col-8 text-center"></div>
            <div class="col-5  text-center"></div>
            <span class="ft11">
              Nombre:
              <span class="ft11Black"
                ><span v-bind:class="{ marca: data.showMarca }">
                  {{ data.nombre_cliente }}</span
                ></span
              >
              <br /><br />
            </span>
          </div>
          <div class="col-10 row p-3">
            <div class="col-5 text-center"></div>
            <div class="col-5 row">
                <div class="col-3"> <span class="ft11">Firma</span></div>
                <div class="col-9 border-bottom border-dark"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";

export default {
  name: "AboutYou",
  data() {
    return {};
  },
  validations() {
    return {};
  },
  props: {
    data: {
      type: Object
    }
  },
  methods: {
    preloader() {
      $(".preloader").fadeIn();
      $(".preloader")
        .delay(10)
        .fadeIn("slow");
    },
    preloaderHiden() {
      $(".preloader").fadeOut();
      $(".preloader")
        .delay(10)
        .fadeOut("slow");
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  components: {},
  created() {
    window.scrollTo(0, 0);
  }
};
</script>
<style type="text/scss">
@import "../style.scss";
</style>



// WEBPACK FOOTER //
// src/views/Contratos/Caratura1/CartaClienteNoConoce.vue